export const EXAMPLE_LINGERIE_PROMPTS: string[] = [
  'a beautiful brunette in black lace lingerie',
  'a blonde in a white satin chemise',
  'a redhead in a burgundy bra and panty set',
  'a Latina woman in green silk lingerie',
  'an Asian woman in pink lace lingerie',
  'a brunette in a nude lace bodysuit',
  'a curvy blonde in a black babydoll slip',
  'a slim brunette in cream lingerie',
  'a tanned woman in a pale blue lingerie set',
  'a woman in black lingerie and sheer stockings',
  'a brunette in lavender satin lingerie',
  'a brunette in a red lace teddy',
  'a blonde in simple white cotton lingerie',
  'a woman in a champagne silk robe over lingerie',
  'a brunette in pastel pink lingerie on a bed',
  'a woman in a black bustier and garter belt',
  'a blonde in dusty rose lace lingerie',
  'a brunette in lingerie in front of a mirror',
  'a brunette in a soft grey lingerie set',
  'a woman in navy blue lace lingerie',
]

export function getRandomPrompt(excludePrompt?: string): string {
  const pool = excludePrompt
    ? EXAMPLE_LINGERIE_PROMPTS.filter((p) => p !== excludePrompt)
    : EXAMPLE_LINGERIE_PROMPTS
  const index = Math.floor(Math.random() * pool.length)
  return pool[index]
}
